import {
    ADD_INVENTORY_SUCCEEDED,
    ADD_INVENTORY_FAILED,
    EDIT_INVENTORY_SUCCEEDED,
    EDIT_INVENTORY_FAILED,
    DELETE_INVENTORY_FAILED,
    DELETE_INVENTORY_SUCCEEDED,
    FETCH_INVENTORY_SUCCEEDED,
    FETCH_INVENTORY_FAILED,
    RESET_ADD_INVENTORY_STATE,
    RESET_EDIT_INVENTORY_STATE,
    FETCH_INVENTORY_STARTED,
    DELETE_INVENTORY_STARTED,
    RESET_DELETE_INVENTORY_STATE,
    RESET_INVENTORY,
    SEARCH_INVENTORY_FAILED,
    SEARCH_INVENTORY_SUCCEEDED,
    SEARCH_INVENTORY_STARTED,
    RESET_SEARCH_INVENTORY,
} from "../actions/types/invoice.types";

const initialState = {
    inventory: [],
    initialInventory: [],
    addInventoryState: "idle",
    deleteState: "idle",
    updateInventoryState: "idle",
    fetchInventoryState: "loading",
    searchInventoryByFilterState: "idle",
    inventoryErrorMessage: "",
};

const invoiceInventoryReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_INVENTORY_STARTED:
            return {
                ...state,
                fetchInventoryState: "loading",
            };

        case FETCH_INVENTORY_FAILED:
            return {
                ...state,
                fetchInventoryState: "failed",
            };

        case FETCH_INVENTORY_SUCCEEDED: {
            const data = Array.isArray(payload.data) ? payload.data : [];

            return {
                ...state,
                fetchInventoryState: "success",
                inventory: data,
                initialInventory: data,
            };
        }

        case SEARCH_INVENTORY_STARTED:
            return {
                ...state,
                searchInventoryByFilterState: "loading",
            };

        case SEARCH_INVENTORY_FAILED:
            return {
                ...state,
                searchInventoryByFilterState: "failed",
            };

        case SEARCH_INVENTORY_SUCCEEDED: {
            const data = Array.isArray(payload.data) ? payload.data : [];

            return {
                ...state,
                searchInventoryByFilterState: "success",
                inventory: data,
            };
        }

        case ADD_INVENTORY_SUCCEEDED: {
            return {
                ...state,
                addInventoryState: "success",
            };
        }

        case ADD_INVENTORY_FAILED: {
            return {
                ...state,
                addInventoryState: "failed",
                inventoryErrorMessage: payload,
            };
        }

        case RESET_ADD_INVENTORY_STATE: {
            return {
                ...state,
                addInventoryState: "idle",
            };
        }

        case EDIT_INVENTORY_SUCCEEDED: {
            return {
                ...state,
                updateInventoryState: "success",
            };
        }

        case EDIT_INVENTORY_FAILED: {
            return {
                ...state,
                updateInventoryState: "failed",
                inventoryErrorMessage: payload,
            };
        }

        case RESET_EDIT_INVENTORY_STATE: {
            return {
                ...state,
                updateInventoryState: "idle",
            };
        }

        case DELETE_INVENTORY_STARTED: {
            return {
                ...state,
                deleteState: "loading",
            };
        }

        case DELETE_INVENTORY_SUCCEEDED: {
            return {
                ...state,
                deleteState: "success",
            };
        }

        case DELETE_INVENTORY_FAILED: {
            return {
                ...state,
                deleteState: "failed",
                inventoryErrorMessage: payload,
            };
        }

        case RESET_DELETE_INVENTORY_STATE: {
            return {
                ...state,
                deleteState: "idle",
            };
        }

        case RESET_SEARCH_INVENTORY:
            return {
                ...state,
                searchInventoryByFilterState: "idle",
            };

        case RESET_INVENTORY:
            return {
                ...state,
                inventory: state.initialInventory,
            };

        default:
            return state;
    }
};

export { invoiceInventoryReducer };
